import React, { useEffect, useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { getSocket } from '../context/socket'; // adjust the path if needed
import { Avatar } from 'primereact/avatar';

const ChecklistMemberPage = ({ onCancel, togglePopup, cardId, boardId, checklistItemId }) => {
    const socket = getSocket();
    const [users, setUsers] = useState([]);
    const [value, setValue] = useState(null);
    const [items, setItems] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    // 🔄 Fetch eligible users on mount
    useEffect(() => {
        if (socket) {
            socket.emit("fetchFilteredUsers", { board_id: boardId }); // ✅ send board_id
            socket.on('filteredUsersList', (data) => setUsers(data));
            socket.on('errorFetchingUsers', (err) => console.error(err));
        }
        return () => {
            socket?.off('filteredUsersList');
            socket?.off('errorFetchingUsers');
        };
    }, [socket]);

    // 🔎 Autocomplete logic
    const search = (event) => {
        const query = event.query.toLowerCase();
        const filtered = users.filter(user =>
            `${user.first_name} ${user.last_name}`.toLowerCase().includes(query)
        );
        setItems(filtered);
    };

    // ➕ Add selected user to member list
    const handleUserSelect = (user) => {
        if (!selectedUsers.find(u => u.user_id === user.user_id)) {
            setSelectedUsers(prev => [...prev, user]);
        }
        setValue(null);
    };

    // 🧼 Remove user from selection
    const removeUser = (userId) => {
        setSelectedUsers(prev => prev.filter(u => u.user_id !== userId));
    };

    // 💾 Save members to card
    const handleSaveMembers = () => {
        const user_ids = selectedUsers.map(u => u.user_id);
        socket.emit('updateChecklistMembers', { checklistItemId: checklistItemId, members: user_ids, card_id: cardId });
        onCancel();
    };

    return (
        <div className="popup-box popup-members">
            <div className="popup-header">
                Members
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={onCancel} />
            </div>
            <div className="popup-body">
                {/* 👇 Hide this after one user is selected */}
                {selectedUsers.length === 0 && (
                    <AutoComplete
                        value={value}
                        suggestions={items}
                        completeMethod={search}
                        field="first_name"
                        onChange={(e) => setValue(e.value)}
                        onSelect={(e) => handleUserSelect(e.value)}
                        placeholder="Search by name"
                        className="ser_EMP"
                        itemTemplate={(item) => (
                            <div className="flex align-items-center justify-content-between gap-3">
                                <img
                                    src={item?.profileImage?.image_url || "https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png"}
                                    alt={item.first_name}
                                    style={{ width: '32px', height: '32px', borderRadius: '50%' }}
                                />
                                <span>{item.first_name} {item.last_name}</span>
                            </div>
                        )}
                        selectedItemTemplate={(item) =>
                            item ? (
                                <div className="flex align-items-center justify-content-between gap-3">
                                    <img
                                        src={item?.profileImage?.image_url || "https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png"}
                                        alt={item.first_name}
                                        style={{ width: '20px', height: '20px', borderRadius: '50%' }}
                                    />
                                    <span>{item.first_name} {item.last_name}</span>
                                </div>
                            ) : ''
                        }
                    />
                )}



                <div className="selected-members mt-3">
                    <p><b>Selected Member:</b></p>
                    <ul className="list-EmpLIst">
                        {selectedUsers.map(user => (
                            <li key={user.user_id} className="d-flex align-items-center justify-content-between gap-2">
                                <div className='d-flex align-items-center '>
                                    <Avatar
                                        image={user.profileImage?.image_url || 'https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png'}
                                        shape="circle"
                                        size="large"
                                    />
                                    {user.first_name} {user.last_name}
                                </div>
                                <Button icon="pi pi-trash" className="p-button-text text-danger p-0 ml-2" onClick={() => removeUser(user.user_id)} />
                            </li>
                        ))}
                    </ul>
                </div>

                <Button severity='success' label="Save" className="border-0 py-1 px-3 mt-1 me-2" onClick={handleSaveMembers} />
            </div>
        </div>
    );
};

export default ChecklistMemberPage;
